import PropTypes from 'prop-types';

const HeroImage = ({ className = '', ...props }) => (
  <svg
    width="144"
    height="185"
    viewBox="0 0 144 185"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M73.874 0.0136719C96.8109 0.594982 115.226 19.3713 115.226 42.4482L115.226 64.9199C115.226 88.3632 96.2215 107.368 72.7783 107.368L71.6826 107.354C48.7455 106.773 30.3301 87.997 30.3301 64.9199L30.3301 42.4482C30.3301 19.0049 49.335 4.09663e-07 72.7783 0L73.874 0.0136719ZM72.7783 19.9756C60.3671 19.9756 50.3057 30.0371 50.3057 42.4482L50.3057 64.9199C50.3057 77.3311 60.3671 87.3926 72.7783 87.3926C85.1894 87.3924 95.251 77.331 95.251 64.9199L95.251 42.4482C95.251 30.0372 85.1894 19.9757 72.7783 19.9756Z"
      fill="#0A0777"
    />
    <path
      d="M72.4112 79.1734C92.4984 47.7752 144.822 61.3367 144.822 100.601C144.822 159.652 72.4112 186.646 72.4112 186.646C72.4112 186.646 0 158.527 0 100.601C0 61.3367 52.324 47.7752 72.4112 79.1734Z"
      fill="white"
    />
    <path
      d="M90.9861 113.022C90.9861 103.432 83.153 95.6558 73.4908 95.6558C63.8285 95.6558 55.9937 103.43 55.9937 113.022C55.9937 120.319 60.5344 126.555 66.9599 129.123L56.8778 153.983H90.1057L80.0235 129.123C86.449 126.553 90.9898 120.319 90.9898 113.022H90.9861Z"
      fill="#FB6E44"
    />
  </svg>
);

HeroImage.propTypes = {
  className: PropTypes.string
};

export default HeroImage;
